<div class="row" #areasContainer>
	<div class="col-12 executive-btns-wrapper">


		<div class="price" *ngIf="showPrice">
			<span *ngIf="priceValue; else noPrice">{{ priceValue | number:'1.2-2': currLng }} {{ currency }}</span>
			<ng-template #noPrice><span>---</span></ng-template>
		</div>



		<div class="buttonGroup">
			<kendo-buttongroup selection="single" kendoTooltip class="area-buttons">
				<button kendoButton [selected]="selected == 'Left'" [toggleable]="true" (selectedChange)="selectArea('Left')"
					i18n-title="Areas|Tooltip:Left" title="Left">{{ areaSymbol('Left') }}
				</button>
				<button kendoButton [selected]="selected == 'Right'" [toggleable]="true"
					(selectedChange)="selectArea('Right')" i18n-title="Areas|Tooltip:Right"
					title="Right">{{ areaSymbol('Right') }}</button>
				<button kendoButton [selected]="selected == 'Roof'" [toggleable]="true"
					(selectedChange)="selectArea('Roof')" i18n-title="Areas|Tooltip:Top"
					title="Top">{{ areaSymbol('Roof') }}</button>
				<button kendoButton [selected]="selected == 'Front'" [toggleable]="true"
					(selectedChange)="selectArea('Front')" i18n-title="Areas|Tooltip:Front"
					title="Front">{{ areaSymbol('Front') }}</button>
				<button *ngIf="projectService.template.isStandalone" kendoButton [selected]="selected == 'Rear'"
					[toggleable]="true" (selectedChange)="selectArea('Rear')" i18n-title="Areas|Tooltip:Rear"
					title="Rear">{{ areaSymbol('Rear') }}</button>
			</kendo-buttongroup>
		</div>

		<div class="buttonGroup">
			<kendo-buttongroup selection="single" kendoTooltip class="area-buttons">
				<button kendoButton [selected]="selectedView == 'Design'" [toggleable]="true" (selectedChange)="selectView('Design')"
					i18n-title="Areas|Tooltip:Desing" title="Desing" [svgIcon]="projectService.svgIcons.buildingBlocksIcon">
				</button>
				<button kendoButton [selected]="selectedView == 'Options'" [toggleable]="true"
					(selectedChange)="selectView('Options')" i18n-title="Areas|Tooltip:Options list"
					title="Options list" [svgIcon]="projectService.svgIcons.listUnorderedSquareIcon">
				</button>
			</kendo-buttongroup>
		</div>
		<div class="buttonGroup">
			<kendo-buttongroup selection="multiple" kendoTooltip class="area-buttons">
				<button kendoButton [toggleable]="true" [selected]="layerOutside" (selectedChange)="changeLayer('layerOutside')"
					i18n-title="Common|Outside layer" title="Outside layer">
					<img src="../../../assets/icons/layerOutside.png">
				</button>
				<button kendoButton [toggleable]="true" [selected]="layerMiddle" (selectedChange)="changeLayer('layerMiddle')"
					i18n-title="Common|Middle layer" title="Middle layer">
					<img src="../../../assets/icons/layerMiddle.png">
				</button>
				<button kendoButton [toggleable]="true" [selected]="layerInside" (selectedChange)="changeLayer('layerInside')"
					i18n-title="Common|Inside layer" title="Inside layer">
					<img src="../../../assets/icons/layerInside.png">
				</button>
				<button kendoButton [toggleable]="true" [selected]="layerDimensions" (selectedChange)="changeDimensions()"
					i18n-title="Toolbar|'Dimensions' button tooltip" title="Dimensions">
					<img src="../../../assets/icons/layerDimensions.png">
				</button>
			</kendo-buttongroup>
		</div>

		<div class="buttonGroup">

			<div kendoTooltip>
				<div [attr.title]="zoomInLabel">
					<button kendoButton class="k-button executive-btns" (click)="onZoom(1)"
						[disabled]="zoomInDisabled()" [svgIcon]="projectService.svgIcons.zoomInIcon">
					</button>
				</div>
			</div>

			<div kendoTooltip>
				<div [attr.title]="zoomResetLabel">
					<button kendoButton class="k-button executive-btns" (click)="onZoom(0)"
						[svgIcon]="projectService.svgIcons.zoomActualSizeIcon">
					</button>
				</div>
			</div>

			<div kendoTooltip>
				<div [attr.title]="zoomOutLabel">
					<button kendoButton class="k-button executive-btns" (click)="onZoom(-1)"
						[disabled]="zoomOutDisabled()" [svgIcon]="projectService.svgIcons.zoomOutIcon">
					</button>
				</div>
			</div>
		</div>

		<div class="buttonGroup">
			<div kendoTooltip *ngIf="!projectService.readOnly">
				<div [attr.title]="rewindLabel">
					<button kendoButton class="k-button executive-btns" (click)="onRewind()"
						[disabled]="undoDisabled || toolBSrvc.getCurrTool()"
						[svgIcon]="projectService.svgIcons.rewindIcon">
					</button>
				</div>
			</div>

			<div kendoTooltip *ngIf="!projectService.readOnly">
				<div [attr.title]="undoLabel">
					<button kendoButton class="k-button executive-btns" (click)="onUndo()"
						[disabled]="undoDisabled || toolBSrvc.getCurrTool()"
						[svgIcon]="projectService.svgIcons.undoIcon">
					</button>
				</div>
			</div>

			<div kendoTooltip *ngIf="!projectService.readOnly">
				<div [attr.title]="redoLabel">
					<button kendoButton class="k-button executive-btns" (click)="onRedo()"
						[disabled]="redoDisabled || toolBSrvc.getCurrTool()"
						[svgIcon]="projectService.svgIcons.redoIcon">
					</button>
				</div>
			</div>
		</div>

		<div class="buttonGroup">
			<div kendoTooltip>
				<div>
					<button kendoButton class="k-button executive-btns"
						(click)="showValidationPopup = !showValidationPopup" [svgIcon]="validationIcon" #anchor2
						[themeColor]="projectService.errors?.length > 0 ? 'error' : 'success'">
					</button>
				</div>
			</div>

			<kendo-popup [anchor]="anchor2.element" *ngIf="showValidationPopup" #popup2>
				<div *ngIf="projectService.errors?.length == 0" class="validation-message">
					<div i18n="Common|Project is valid">Project is valid</div>
				</div>
				<div *ngIf="projectService.errors?.length > 0" class="validation-message">
					<ul>
						<li *ngFor="let d of projectService.errors">{{ d }}</li>
					</ul>
				</div>
			</kendo-popup>

			<div kendoTooltip>
				<div [attr.title]="printLabel">
					<button kendoButton class="k-button executive-btns" (click)="onPrint()"
						[disabled]="toolBSrvc.getCurrTool()" [svgIcon]="projectService.svgIcons.printIcon">
					</button>
				</div>
			</div>

			<div kendoTooltip *ngIf="showUploadButton">
				<div [attr.title]="exportToCRMLabel">
					<button kendoButton class="k-button executive-btns" (click)="onCRMExport()"
						[disabled]="!projectService.isValid || projectService.readOnly" [svgIcon]="projectService.svgIcons.uploadIcon">
					</button>
				</div>
			</div>

			<app-export-popup #bom *ngIf="!showUploadButton"></app-export-popup>

			<div *ngIf="showPrice || this.projectService.readOnly && !showUploadButton">
				<div kendoTooltip>
					<div [attr.title]="closeLabel">
						<button kendoButton class="k-button executive-btns" (click)="onClose()" [disabled]="!priceValue"
							[svgIcon]="projectService.svgIcons.xIcon">
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>


	<div class="row" *ngIf="projectService.readOnly">
		<div class="col-12 executive-btns-wrapper">
			<span class="prop-read-only" i18n="Toolbar|'Read-only mode' label">Read-only mode</span>
		</div>
	</div>
	<div class="row" *ngIf="projectService.draftMode">
		<div class="col-12 executive-btns-wrapper">
			<span class="prop-draft" i18n="Toolbar|'Test modetest' label">TEST MODE</span>
		</div>
	</div>

</div>

<new-request-dialog [dialogOpened]="requestDialog" [offerResponse]="offerResponse"></new-request-dialog>